// src/components/Admin/Leads/KanbanColumn.jsx
import React, { useMemo } from "react";
import { Droppable } from "@hello-pangea/dnd";
import { LeadCard } from "./LeadCard";
import { formatMoney } from "../../../utils/money";
import './Leads.scss';

export function KanbanColumn({   
  stage,
  leads,
  onLeadClick,
  onAddLead, // 👈 NUEVO
  currency = "PEN",
  locale = "es-PE",}) {
  const droppableId = String(stage.id);

const totalEstimated = useMemo(() => {
  const sum = (leads || []).reduce((acc, l) => {
    const v = typeof l?.estimated_value === "string" ? Number(l.estimated_value) : l?.estimated_value;
    return acc + (Number.isFinite(v) ? v : 0);
  }, 0);
  return formatMoney(sum, { currency, locale });
}, [leads, currency, locale]);


console.log(leads);



  return (
    <div
      style={{
        minWidth: 320,
        maxWidth: 360,
        marginRight: 12,
        background: stage?.color,
        borderRadius: 8,
        padding: 8,
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.05)",
      }}
    > 
    <div style={{ padding: "8px 8px 12px 8px" }}>
        <div>
          <strong>{stage.name}</strong>
          <span style={{ opacity: 0.6 }}>({leads.length})</span>
          <button
            type="button"
            onClick={() => onAddLead?.(stage)}   // 👈 pasa stage completo
            style={{
              border: "none",
              borderRadius: 6,
              padding: "6px 10px",
              cursor: "pointer",
              background: "rgba(255,255,255,0.85)",
            }}
            title="Agregar lead"
          >
            +
          </button>
          </div>
          <div>
          <span className="numberBig">{totalEstimated}</span>
        </div>
      </div>
      

      <Droppable droppableId={droppableId}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            style={{
              minHeight: 50,
              padding: 4,
              borderRadius: 6,
              background: snapshot.isDraggingOver ? "#eef6ff" : "transparent",
              transition: "background 150ms",
            }}
          >
            {leads.map((lead, index) => (
              <LeadCard 
              key={lead.id} 
              lead={lead} 
              index={index} 
              onClick={onLeadClick} 
              
              />
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </div>
  );
}
